export default __webpack_public_path__ + "static/media/round_2.37f74dd9.svg";